import React, { useEffect } from "react";

import "./styles.scss";
import ESGSureLogo from "../../images/ESG-Sure-Logo.svg"
import { useSelector } from "react-redux";
import { message } from "antd";

const AuthLayoutMain = ({ Component, hideHeader }) => {
    const { success: loginSuccess } = useSelector(state => state.otp)
    const { logout } = useSelector((state) => state.logout)

    useEffect(() => {
        if (loginSuccess) {
            message.success("Login successful!")
        }
    }, [loginSuccess])

    useEffect(() => {
        if (logout?.message) {
            message.success("Successfully logged out")
        }
    }, [logout?.message])

    useEffect(() => {
        if (typeof window.Intercom === 'function') {
            window.Intercom('shutdown')
        }
    }, [])

    return (
        <div className="auth-layout-main">
            {!hideHeader && (
                <div className="layout-header">
                    <img
                        className="logo-svg"
                        alt="ESG Sure Logo"
                        src={ESGSureLogo}
                    />
                </div>
            )}
            <div className="layout-body"><Component /></div>
        </div>
    )
}

export default AuthLayoutMain